export default function isCanadianStyle(name) {
  return (
    name.toLowerCase().includes('canada') ||
    name.toLowerCase().includes('canadian')
  );
}
